import { useEffect, useState } from 'react';
import { resolveMediaUrl } from '@/lib/mediaUrl';

/**
 * Resolves a stored image URL to a session-usable URL. Handles data URLs,
 * external hotlinks, and Supabase Storage paths (which are signed on demand).
 *
 * Returns null while resolving or if resolution fails, so callers can render
 * a placeholder while pending.
 */
export function useSignedMediaUrl(url: string | null | undefined): string | null {
  const [resolved, setResolved] = useState<string | null>(() => {
    if (!url) return null;
    if (url.startsWith('data:')) return url;
    return null;
  });

  useEffect(() => {
    let cancelled = false;

    if (!url) {
      setResolved(null);
      return;
    }
    if (url.startsWith('data:')) {
      setResolved(url);
      return;
    }

    resolveMediaUrl(url).then((next) => {
      if (!cancelled) setResolved(next);
    });

    return () => {
      cancelled = true;
    };
  }, [url]);

  return resolved;
}
